<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import "v-tooltip/dist/v-tooltip.css";


export default {
    mixins: [Api, Sabit],
    props: ["Data"],
    components: {

    },
    data() {
        return {
            DetayDonem: null,
            DetayGostergesi: null
            
        };
    },
    watch: {
        Data() {
  
        },
    },
    methods: {
        Get() {

    
        },
        groupBy(array, key) {
      const result = {}
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
        }
        result[item[key]].push(item)
      })
      return result
    },
        Fark(Data){
            var Fark = 0;
            if(Data){
              Fark = Data.Universitehedefi - Data.Birimbazlihedeftoplam  
            }
            return Fark;
        },
    },

    computed: {},
    created() {
        this.DetayData = this.groupBy(this.Data.Detay, 'Donem')
        this.DetayData2 = this.groupBy(this.Data.Detay, 'Gostergesi')
    },
};
</script>
<template>

        <div>
            <table class="table-bordered col-12" >
    <thead>
        <tr style="background-color: #2A3042; border-color:white; border-style: solid; color:white; text-align: left; height: 35px;" :colspan="Object.keys(this.DetayData).length + 4">
            <th class="col-md-3">Amacı</th>
            <th class="col-md-9" :colspan="Object.keys(this.DetayData).length + 4">{{ Data.Amaci }}</th>
        </tr>
        <tr style="background-color: #2A3042; border-color:white; border-style: solid; color:white; text-align: left; height: 35px;" :colspan="Object.keys(this.DetayData).length + 4">
            <th class="col-md-3">Tablo Adı</th>
            <th class="col-md-9" :colspan="Object.keys(this.DetayData).length + 4">{{ Data.Tabloadi }}</th>
        </tr>
        <tr style="background-color: #2A3042; border-color:white; border-style: solid; color:white; text-align: left; height: 35px;" :colspan="Object.keys(this.DetayData).length + 4">
            <th class="col-md-3">Performans Hedefi</th>
            <th class="col-md-9" :colspan="Object.keys(this.DetayData).length + 4">{{ Data.Performanshedef }}</th>
        </tr>
        <tr style="background-color: #2A3042; border-color:white; border-style: solid; color:white; text-align: left; height: 35px;" :colspan="Object.keys(this.DetayData).length + 4">
            <th class="col-md-3">Sorumlu Birim</th>
            <th class="col-md-9" :colspan="Object.keys(this.DetayData).length + 4">{{ Data.Sorumlubirim }}</th>
        </tr>
        <tr style="background-color: #2A3042; border-color:white; border-style: solid; color:white; text-align: left; height: 35px;" :colspan="Object.keys(this.DetayData).length + 4" >
            <th class="col-md-3" :rowspan="Data.Isbirlikci.length-2">İşbirliği Yapılacak Birimler</th>
            <td :colspan="Object.keys(this.DetayData).length + 4" >
            <div v-for="(Birim, index) in Data.Isbirlikci" :key="index" >{{ Birim.Birimadi }}</div>
            </td>

        </tr>
    </thead>
</table>
<table class="col-12">
    <tbody>
        <tr >
            <th class="col-md-3" style="background-color: #2A3042; border-color:white; border-style: solid; color:white; text-align: center; " :rowspan="Object.keys(this.DetayData2).length + 2" colspan="1"
            >Detay
            </th>    
            <td class="col-md-9" style="text-align: center;">
            
                            <tr>
                            <td style="font-weight: bold; background-color: #2a3042; color:#f0f0f0" >Tipi</td>
                            <td style="font-weight: bold; background-color: #2a3042; color:#f0f0f0" >Gösterge</td>
                            <td style="font-weight: bold; background-color: #2a3042; color:#f0f0f0" >Hedef Etkisi</td>
                            <td style="font-weight: bold; background-color: #2a3042; color:#f0f0f0" >Başlangıç Değeri</td>
                            <td style="font-weight: bold; background-color: #2a3042; color:#f0f0f0" v-for="(Data, index) in DetayData" :key="index" >
                                <div>{{ Data[0].Donem }}</div></td>
                           

                            </tr>
                     <tr v-for="(Data, index) in DetayData2" :key="index">
                            <td >{{ Data[0].Tipi }}</td>
                            <td>{{ Data[0].Gostergesi }}</td>                   
                            <td>{{ Data[0].Hedefetkisi }}</td>
                            <td >{{ Data[0].Basdeger }}</td>
                            <td v-for="(SubData, index) in Data" :key="index" >
                                <div>{{ SubData.Deger }}</div></td>
                           

                       
                           
                        </tr>                                                         
             
            </td>
        </tr>
    </tbody>
   
</table>
<br>
<br>
        </div>


</template>
<style>
td {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
